const ruleInstances = {};

function getRule(fn = () => {}) {
	return fn(ruleInstances);
}

function setRule(fn = () => {}) {
	const newState = fn(ruleInstances);
	if (newState) {
		Object.assign(ruleInstances, newState);
	}
}

function removeRule(id) {
	try {
		ruleInstances[id].cleanupThen(true);
	} catch (e) {}
	delete ruleInstances[id];
}

export { getRule, setRule, removeRule, ruleInstances };
